import { useLocation } from "react-router-dom";
import FilterAccordion from "./FilterAccordion";

const isFilterActive = (value, type, searchParams) => {
  const param = searchParams.get(type);
  return param?.split(",").includes(value) || false;
};

const CheckboxGroup = ({ title, type, options, onToggle }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  return (
    <FilterAccordion title={title}>
      <div className="space-y-2">
        {options?.map((item) => (
          <div key={item?.id || item?.name} className="flex items-center">
            <input
              id={`${title}-${item?.id || item?.name}`}
              name={`${title}-${item?.name}`}
              type="checkbox"
              checked={isFilterActive(item?.name, type, searchParams)}
              onChange={() => onToggle(item?.name)}
              className="h-3.5 w-3.5 rounded-sm border-stone-300 text-brand focus:ring-brand"
            />
            <label
              htmlFor={`${title}-${item?.id || item?.name}`}
              className="ml-2.5 font-sans text-[14px] leading-5 font-light text-[#333333]"
            >
              {item?.name}
            </label>
          </div>
        ))}
      </div>
    </FilterAccordion>
  );
};

export default CheckboxGroup;
